import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import WhatsAppChat from "@/components/WhatsAppChat";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    // Prevent soft-404s from being indexed (invisible metadata only)
    let robots = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    const previous = robots?.content ?? null;
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = "noindex, follow";
    return () => {
      if (robots && previous !== null) robots.content = previous;
    };
  }, [location.pathname]);


  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center px-6 animate-fade-in">
        <p className="font-body text-xs tracking-ultra uppercase text-muted-foreground mb-6">
          {t("notFound.error")}
        </p>
        <h1 className="font-serif text-6xl md:text-8xl font-light text-primary mb-8 tracking-wider">
          {t("notFound.title")}
        </h1>
        <p className="font-body text-base text-muted-foreground mb-12 italic max-w-md mx-auto leading-relaxed">
          {t("notFound.description")}
        </p>
        <Button 
          variant="outline" 
          size="lg" 
          asChild
          className="tracking-widest uppercase text-xs"
        >
          <a href="/">{t("notFound.returnHome")}</a>
        </Button>
      </div>
      <WhatsAppChat />
    </div>
  );
};

export default NotFound;